module.exports = __webpack_public_path__ + "img/Close_round.7c353d3b.svg";